import * as tagUtil from "./LogTagData";
import * as Constants from '../components/common/Constants'

const VIEW_DATA = data => {
    try {
        window.tagUtil.view(data);
    } catch (e) {
        tagUtil.logError(e);
    }
}

const startFillingPersonalDetailsPage1 = () => {
    let data = {
        page_event: "view",
        page_name: "ebu: self service: registration",
        service_application_event: "start",
        service_application_name: "ebu:self service: registration (transaction)",
        service_application_step: "ebu: self service: registration",
        service_application_type: "transaction"
    };
    VIEW_DATA(data);
};

const startFillingPersonalDetailsPage2 = (type) => {
    const _type = type === Constants.ON_BOARDING_FIXED ? "fixed" : "mobile";
    let data = {
        page_event: "view",
        page_name: "ebu: self service: registration: " + _type,
        service_application_name: "ebu:self service: registration (transaction)",
        service_application_step: "ebu: self service: registration: " + _type,
        service_application_type: "transaction"
    };
    VIEW_DATA(data);
};

const useUploadDocument = () => {
    let data = {
        page_tool_name: "registration mobile upload documents",
        page_tool_event: "use"
    };
    VIEW_DATA(data);
};

const completeRegistration = (type) => {
    let data = {
        page_event: "view",
        service_application_event: "finish",
        service_application_step: "ebu: self service: registration: "+type+" : success",
        service_application_name: "ebu: self service: registration (transaction)",
        service_application_type: "transaction",
        page_name: "ebu: self service: registration: success",
        complete_registration: "completed"
    };
    VIEW_DATA(data);
};

const errorRegistration = (msg) => {
    let data = {

        page_form_event: "error",
        page_errors: msg,
        page_name: "ebu: self service: registration: journey error"
    };
    VIEW_DATA(data);
};

const registrationTechnicalError = (msg) => {

    let data = {
        page_form_event: "error",
        page_errors: msg,
        page_name: "vodacom: business: self service: registration: technical error"
    };
    VIEW_DATA(data);
}

const registrationBillingAccountError = (msg) => {

    let data = {
        page_form_event: "error",
        page_errors: msg,
        page_name: "vodacom: business: self service: registration: account not found"
    };
    VIEW_DATA(data);
}

const loginTechnicalError = (msg) => {

    let data = {
        page_form_event: "error",
        page_errors: msg,
        page_name: "vodacom: business: self service: login: technical error"  
    };
    VIEW_DATA(data);  
}   

export {
    errorRegistration,
    completeRegistration,
    useUploadDocument,
    startFillingPersonalDetailsPage2,
    startFillingPersonalDetailsPage1,
    registrationTechnicalError,
    loginTechnicalError,
    registrationBillingAccountError
};
